import { useInput } from 'react-admin';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from '../../../ck5editor/build/ckeditor';
import '../../CKEditor.css';

class Timestamp {
  init() {
    const editor = this.editor;
    console.log('Timestamp was initialized.');
    console.log(editor);
    editor.ui.addButton('btn_readmore', {
      label: 'Read more',
      command: 'ckeditor_readmore',
      icon: this.path + 'icons/readmore.png',
    });

    var cssPath = this.path + 'readmore.css';
    editor.on('mode', function () {
      if (editor.mode === 'wysiwyg') {
        this.document.appendStyleSheet(cssPath);
      }
    });

    // Prevent nesting by disabling button.
    editor.on('selectionChange', function (evt) {
      if (editor.readOnly) {
        return;
      }
      var command = editor.getCommand('ckeditor_readmore');
      var element =
        evt.data.path.lastElement &&
        evt.data.path.lastElement.getAscendant('div', true);
      if (element) {
        command.setState(Editor.TRISTATE_DISABLED);
      } else {
        command.setState(Editor.TRISTATE_OFF);
      }
    });

    var allowedContent = 'div(!ckeditor-readmore)';

    // Wrap selection.
    editor.addCommand('ckeditor_readmore', {
      allowedContent: allowedContent,

      exec: function (editor) {
        var selectedHtml = '';
        var selection = editor.getSelection();

        if (selection) {
          selectedHtml = getSelectionHtml(selection);
        }

        var div = new Editor.dom.element.createFromHtml(
          '<div class="ckeditor-readmore">' + selectedHtml + '</div>'
        );
        editor.insertElement(div);

        function getSelectionHtml(selection) {
          var ranges = selection.getRanges();
          var html = '';
          for (var i = 0; i < ranges.length; i++) {
            html += getRangeHtml(ranges[i]);
          }
          return html;
        }

        function getRangeHtml(range) {
          var content = range.extractContents();
          // `content.$` is an actual DocumentFragment object
          // (not a CKEDitor abstract)
          var children = content.$.childNodes;
          var html = '';
          for (var i = 0; i < children.length; i++) {
            var child = children[i];
            if (typeof child.outerHTML === 'string') {
              html += child.outerHTML;
            } else {
              html += child.textContent;
            }
          }
          return html;
        }
      },
    });
  }
}

export const CkEditorInput = ({ source, label, name, ...rest }) => {
  const { id, field, fieldState, formState } = useInput({ source });

  return (
    <div id={id} name={name}>
      <label htmlFor={id}>{label}</label>
      <CKEditor
        label={label}
        editor={Editor}
        data={field.value}
        config={{
          // extraPlugins: [
          //   Timestamp,
          // ],
          // entities_latin: false,
          // entities_greek: false,
          // entities: false,
          // basicEntities: false,
          // htmlEncodeOutput: false,
          style: {
            definitions: [
              {
                name: 'Button Small',
                element: 'a',
                classes: ['btn', 'btn-primary', 'btn-normal'],
              },
              {
                name: 'Button Large',
                element: 'a',
                classes: ['btn', 'btn-primary', 'btn-large'],
              },
              {
                name: 'Desktop visible',
                element: 'p',
                classes: ['visible-md'],
              },
              {
                name: 'Mobile visible',
                element: 'p',
                classes: ['hidden-md'],
              },
              {
                name: 'Text small',
                element: 'p',
                classes: ['text-small'],
              },
            ],
          },
        }}
        onReady={(editor) => {
          // You can store the "editor" and use when it is needed.
          console.log('Editor is ready to use!', editor);
        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          field.onChange(data);
          // console.log({event, editor, data});
        }}
        onBlur={(event, editor) => {
          // console.log('Blur.', editor);
        }}
        onFocus={(event, editor) => {
          // console.log('Focus.', editor);
        }}
        {...rest}
      />
    </div>
  );
};
